import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NotificationsAlarmComponent } from './components/notifications-alarm/notifications-alarm.component';
import { NotificationsListComponent } from './components/notifications-list/notifications-list.component';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { NotificationsFactory } from './notifications.factory';

@NgModule({
    imports: [SharedModule, RouterModule],
    declarations: [NotificationsAlarmComponent, NotificationsListComponent, NotificationItemComponent],
    exports: [NotificationsAlarmComponent, NotificationsListComponent, NotificationItemComponent],
    providers: [NotificationsFactory],
})
export class NotificationsSharedModule {}
